import appStats from "../../views/appStats.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "stats";
  const params = ["page", "limit"];

  $stateProvider.state("stats", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appStats,
      },
    },
    reloadOnSearch: false,
    data: { title: "Stats" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/stats/stats.urls.js